import React, { useEffect, useState } from 'react';

import cn from 'classnames';

import styles from './Switch.module.css';

type SwitchProps = {
  checked?: boolean;
  disabled?: boolean;
} & React.ButtonHTMLAttributes<HTMLButtonElement>;

export const Switch = React.forwardRef<HTMLButtonElement, SwitchProps>(
  ({ checked, disabled, className, ...props }, ref) => {
    const [internalValue, setInternalValue] = useState<boolean>(
      checked || false,
    );

    useEffect(() => {
      setInternalValue(checked || false);
    }, [checked]);

    return (
      <button
        {...props}
        ref={ref}
        className={cn(
          styles.switch,
          { [styles.on]: internalValue, [styles.disabled]: disabled },
          className,
        )}
        disabled={disabled}
        type="button"
        role="switch"
        aria-checked={internalValue}
        aria-readonly={disabled}
        onClick={(ev) => {
          setInternalValue(!internalValue);
          props.onClick && props.onClick(ev);
        }}
      >
        <span />
      </button>
    );
  },
);

Switch.displayName = 'Switch';
